// src/pages/VerifyCodePage.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { verifyCode } from "../services/auth";
import logo from "../assets/Logo_DMARCOne.png";

function VerifyCodePage() {
  const navigate = useNavigate();
  const [correo, setCorreo] = useState("");
  const [codigo, setCodigo] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const correoGuardado = localStorage.getItem("auth_correo_pendiente");
    if (!correoGuardado) {
      navigate("/login");
      return;
    }
    setCorreo(correoGuardado);
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const resp = await verifyCode(correo, codigo);

      localStorage.setItem("auth_token", resp.access_token);
      localStorage.setItem("auth_nombre", resp.nombre);
      localStorage.setItem("auth_rol", resp.rol);
      localStorage.setItem("auth_correo", resp.correo);
      localStorage.setItem("auth_numcliente", resp.numcliente ?? "");

      localStorage.removeItem("auth_correo_pendiente");
      navigate("/");
    } catch (err) {
      setError(err.message || "Error al validar código");
    } finally {
      setLoading(false);
    }
  };

  const volverAlLogin = () => {
    localStorage.removeItem("auth_correo_pendiente");
    navigate("/login");
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{ backgroundColor: "#414142" }} // gris oscuro corporativo
    >
      <div
        className="w-full max-w-md rounded-2xl shadow-xl p-8"
        style={{
          backgroundColor: "#FFFFFF",
          border: "1px solid #E5E7EB",
        }}
      >
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <img src={logo} alt="DMARCONE" className="w-60 h-auto" />
        </div>

        <h1
          className="text-xl font-semibold text-center mb-1"
          style={{ color: "#414142" }}
        >
          Verificación en dos pasos
        </h1>

        <p className="text-sm text-center mb-6" style={{ color: "#6B7280" }}>
          Ingresa el código enviado a:
          <br />
          <span className="font-medium" style={{ color: "#414142" }}>
            {correo}
          </span>
        </p>

        {error && (
          <div className="mb-4 rounded-md bg-red-50 border border-red-200 px-3 py-2 text-sm text-red-700">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label
              className="block text-sm font-medium mb-1"
              style={{ color: "#414142" }}
            >
              Código de verificación
            </label>
            <input
              type="text"
              value={codigo}
              onChange={(e) => setCodigo(e.target.value)}
              required
              className="w-full rounded-lg border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#00C4CC] focus:border-[#00C4CC]"
              style={{
                borderColor: "#D1D5DB",
                color: "#414142",
              }}
              placeholder="Ej: 123456"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-lg text-white text-sm font-medium py-2.5 transition disabled:opacity-50 disabled:cursor-not-allowed"
            style={{
              backgroundColor: "#00C4CC",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#00AEB5")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#00C4CC")}
          >
            {loading ? "Verificando..." : "Validar código"}
          </button>
        </form>

        <button
          onClick={volverAlLogin}
          className="w-full mt-4 text-xs transition"
          style={{
            color: "#6B7280",
          }}
          onMouseEnter={(e) => (e.target.style.color = "#414142")}
          onMouseLeave={(e) => (e.target.style.color = "#6B7280")}
        >
          Volver al inicio de sesión
        </button>
      </div>
    </div>
  );
}

export default VerifyCodePage;
